
import { defineComponent, ref, getCurrentInstance } from "vue-demi";
import gsap from "gsap";
import { API_TNotificationsShortListItem } from "@/models/notifications";
import { SMUser } from "@/store";

export default defineComponent({
  name: "Accordion",

  props: {
    items: { type: Array as () => API_TNotificationsShortListItem[], default: () => [] },
  },

  components: {
    NotificationsTag: () => import("@/modules/Notifications/components/NotificationsTag.vue"),
    NotificationsDate: () => import("@/modules/Notifications/components/NotificationsDate.vue"),
  },

  setup() {
    const activeIndex = ref<number | null>(null);
    const contentRefs = ref<Record<number, HTMLElement>>({});

    function toggle(index: number) {
      activeIndex.value = activeIndex.value === index ? null : index;
    }

    function setContentEl(index: number, el: HTMLElement | null) {
      if (el) contentRefs.value[index] = el;
    }

    function onEnter(el: HTMLElement, done: () => void) {
      gsap.fromTo(
        el,
        { height: 0, opacity: 0 },
        {
          height: el.scrollHeight,
          opacity: 1,
          duration: 0.3,
          ease: "power2.out",
          onComplete: () => {
            el.style.height = "auto";
            done();
          },
        }
      );
    }

    function onLeave(el: HTMLElement, done: () => void) {
      gsap.to(el, {
        height: 0,
        opacity: 0,
        duration: 0.3,
        ease: "power2.inOut",
        onComplete: done,
      });
    }

    const router = getCurrentInstance()?.proxy?.$router;

    async function openItem(id: number) {
      try {
        await router.push(`${SMUser.basePath}/notifications/${id}`);
      } catch {
        return;
      }
    }

    return {
      activeIndex,
      toggle,
      onEnter,
      onLeave,
      setContentEl,
      openItem,
    };
  },
});
